module.exports = __webpack_public_path__ + "static/TEKDiagram-762bd2f001c1d040fbe085cf48d75f1c.mp4";